const tutorialText = {
  fontSize: {
    xs: 20,
    sm: 24,
    md: 32,
  },
  textAlign: 'center',
  color: 'text.secondary',
};

export { tutorialText };
